<template>
  <v-container class="app-container--width-max">
    <BaseStepper
      v-if="isShowStepperBase"
      class="mb-1"
      :key="isQuestionSteps"
      :steps="isQuestionSteps ? questionSteps : applicationSteps"
    />
    <BaseAlert
      color="var(--orange-100)"
      class="quote-expired-message"
      :class="{ 'mt-5 mx-md-2 mx-3': isCoverTypePage }"
      v-if="this.isExpired"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--orange-500)">mdi-alert</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> This quote has expired.
          Please check all the details below are accurate and submit a new
          quote.
        </div>
      </div>
    </BaseAlert>
    <QuoteErrorAlert
      v-if="hasQuotes && !isQuoteResultPage"
      :isQuotationStage="isQuestionSteps"
    />
    <router-view ref="routerView" v-show="!restoringLastStep" />
  </v-container>
</template>

<script>
import { applyThirdPartyId } from "@/common/utils";
import BaseStepper from "@/components/BaseComponents/BaseStepper.vue";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters, mapState } from "vuex";

export default {
  name: "D2CLandlordsLayout",
  components: {
    BaseStepper,
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert.vue"),
    QuoteErrorAlert: () => import("@/components/QuoteErrorAlert.vue"),
  },
  props: {
    urlParams: Object,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "isExpired",
      "isQuoteResultPage",
      "hasQuotes",
    ]),
    ...mapState(QUESTIONS_MODULE, ["questionMap", "restoringLastStep"]),
    currentRouteName() {
      return this.$route.name;
    },
    isShowStepperBase() {
      return ![
        ROUTE_NAME.LANDLORDS.D2C.COVER_TYPE,
        ROUTE_NAME.LANDLORDS.D2C.COMPLETE,
      ].includes(this.currentRouteName);
    },
    isQuestionSteps() {
      return [
        ROUTE_NAME.LANDLORDS.D2C.YOUR_DETAILS,
        ROUTE_NAME.LANDLORDS.D2C.PROPERTY_DETAILS,
        ROUTE_NAME.LANDLORDS.D2C.COVER_DETAILS,
      ].includes(this.currentRouteName);
    },
    isCoverTypePage() {
      return this.currentRouteName === ROUTE_NAME.LANDLORDS.D2C.COVER_TYPE;
    },
  },
  data() {
    return {
      questionSteps: [
        {
          stepNumber: 1,
          label: "Your details",
          routeName: ROUTE_NAME.LANDLORDS.D2C.YOUR_DETAILS,
        },
        {
          stepNumber: 2,
          label: "Property details",
          routeName: ROUTE_NAME.LANDLORDS.D2C.PROPERTY_DETAILS,
        },
        {
          stepNumber: 3,
          label: "Your cover",
          routeName: ROUTE_NAME.LANDLORDS.D2C.COVER_DETAILS,
        },
      ],
      applicationSteps: [
        {
          stepNumber: 4,
          label: "Your quote",
          routeName: ROUTE_NAME.LANDLORDS.D2C.QUOTATION_RESULT,
        },
        {
          stepNumber: 5,
          label: "Your application",
          routeName: ROUTE_NAME.LANDLORDS.D2C.APPLICATION,
        },
        {
          stepNumber: 6,
          label: this.$vuetify.breakpoint.lgAndUp
            ? "Payment & renewal"
            : "Payment",
          routeName: ROUTE_NAME.LANDLORDS.D2C.PAYMENT,
        },
      ],
    };
  },
  async mounted() {
    try {
      applyThirdPartyId(true);
      return;
    } catch (e) {
      console.error(e);
    }
  },
};
</script>

<style lang="scss" scoped>
:deep(.section-remider-text) {
  margin-bottom: 27px !important;
}
:deep(.save-exit-button) {
  color: #272727;
}
</style>
